export const Linkouts = {
  Handbook: {
    FunAndGames:
      'https://porschedigital.sharepoint.com/sites/pdhrhandbook/SitePages/You-as-an-employee.aspx#fun-games',
    Education:
      'https://porschedigital.sharepoint.com/sites/pdhrhandbook/SitePages/You-as-an-employee.aspx#education-budget',
  },
} as const;
